import React from "react";
import type { Meta, StoryObj } from "@storybook/react";
import { createNativeStackNavigator } from "@react-navigation/native-stack";

import { MockedProvider } from "@apollo/client/testing/react";
import { GET_ASSET } from "../../graphql/asset";
import { buildAsset, buildSalary } from "../factories";
import SalaryDetailsScreen from "../../screens/worker/SalaryDetails";
import { GET_SALARY } from "../../graphql/salaries";
import { StoryStackNavigatorContainer } from "../display-helpers";

const Stack = createNativeStackNavigator<{
    SalaryDetails: { salaryId: string };
}>();

const StoryComponent = () => {
    const mocks = [
        {
            request: {
                query: GET_SALARY,
                variables: {
                    salaryId: "007",
                },
            },
            maxUsageCount: Number.POSITIVE_INFINITY,
            result: () => ({
                data: {
                    getSalary: buildSalary({
                        id: "007",
                        salaryAsset: buildAsset({
                            id: "asset-01",
                        }),
                    }),
                },
            }),
        },
        {
            request: {
                query: GET_ASSET,
                variables: {
                    assetId: "asset-01",
                },
            },
            maxUsageCount: Number.POSITIVE_INFINITY,
            result: () => {
                return {
                    data: {
                        getAsset: buildAsset({ id: "asset-01" }),
                    },
                };
            },
        },
    ];
    return (
        <MockedProvider mocks={mocks}>
            <StoryStackNavigatorContainer>
                <Stack.Navigator initialRouteName="SalaryDetails">
                    <Stack.Screen
                        name="SalaryDetails"
                        component={SalaryDetailsScreen}
                        options={{ headerShown: true, title: "Fiche de salaire" }}
                        initialParams={{
                            salaryId: "007",
                        }}
                    />
                </Stack.Navigator>
            </StoryStackNavigatorContainer>
        </MockedProvider>
    );
};

const meta = {
    title: "Screens/Salary details",
    component: StoryComponent,
    argTypes: {},
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {};
